// src/App.js - Updated with Cart Context, Auth Context, Order History Context, Profile Context, and Reviews Context
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { OrderHistoryProvider } from './context/OrderHistoryContext';
import { ProfileProvider } from './context/ProfileContext';
import { ReviewsProvider } from './context/ReviewsContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Import Pages
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import ContactPage from './pages/ContactPage';
import CartPage from './pages/CartPage';
import AuthPage from './pages/AuthPage';
import CheckoutPage from './pages/CheckoutPage';
import UserProfilePage from './pages/UserProfilePage';
import AboutPage from './pages/AboutPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import OrderSuccessPage from './pages/OrderSuccessPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import ReviewsPage from './pages/ReviewsPage';
import LoginPage from './pages/LoginPage';

// Import Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

// Import Styles
import './App.css';

function App() {
  useEffect(() => {
    console.log('🇳🇬 TiwaTinwa Customer App Loading...');
    
    // Add global cart notification function
    window.showCartNotification = (message) => {
      // Create notification element
      const notification = document.createElement('div');
      notification.textContent = message;
      notification.style.cssText = `
        position: fixed;
        top: 100px;
        right: 20px;
        background: linear-gradient(135deg, #008751, #fb923c);
        color: white;
        padding: 1rem 2rem;
        border-radius: 25px;
        font-weight: 700;
        z-index: 10000;
        animation: slideInRight 0.5s ease, fadeOut 0.5s ease 2.5s;
        box-shadow: 0 8px 25px rgba(0,0,0,0.2);
      `;
      
      document.body.appendChild(notification);
      
      // Remove after 3 seconds
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 3000);
    };

    // Add notification animations
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideInRight {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes fadeOut {
        to { opacity: 0; transform: translateX(100%); }
      }
    `;
    document.head.appendChild(style);
  }, []);

  return (
    <BrowserRouter>
      <OrderHistoryProvider>
        <AuthProvider>
          <CartProvider>
            <ProfileProvider>
              <ReviewsProvider>
                <div className="App">
                  <Navbar />
                  <main>
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/menu" element={<MenuPage />} />
                      <Route path="/contact" element={<ContactPage />} />
                      <Route path="/cart" element={<CartPage />} />
                      <Route path="/auth" element={<AuthPage />} />
                      <Route path="/checkout" element={<CheckoutPage />} />
                        <Route path="/profile" element={<UserProfilePage />} />
                      <Route path="/about" element={<AboutPage />} />
                      <Route path="/orders" element={<OrderHistoryPage />} />
                      <Route path="/orders/:orderId" element={<OrderTrackingPage />} />
                      <Route path="/order-success" element={<OrderSuccessPage />} />
                      <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
                      <Route path="/reviews" element={<ReviewsPage />} />
                      <Route path="/login" element={<LoginPage />} />
                    </Routes>
                  </main>
                  <Footer />
                  <ToastContainer position="top-right" autoClose={3500} />
                </div>
              </ReviewsProvider>
            </ProfileProvider>
          </CartProvider>
        </AuthProvider>
      </OrderHistoryProvider>
    </BrowserRouter>
  );
}

export default App;